import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';
import type { ConfirmDeleteDialogProps } from './table.types';

const ConfirmDeleteDialog = ({
  open,
  title = 'Confirm Deletion',
  message = 'Are you sure you want to delete this item? This action cannot be undone.',
  confirmLabel = 'Delete',
  cancelLabel = 'Cancel',
  disableBackdropClose = true,
  disableEscapeKeyDown = true,
  onCancel,
  onConfirm,
}: ConfirmDeleteDialogProps) => {
  return (
    <Dialog
      open={open}
      onClose={(_event, reason) => {
        if (disableBackdropClose && reason === 'backdropClick') {
          return;
        }
        if (disableEscapeKeyDown && reason === 'escapeKeyDown') {
          return;
        }
        onCancel();
      }}
      disableEscapeKeyDown={disableEscapeKeyDown}
    >
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <DialogContentText>{message}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel} color="primary">
          {cancelLabel}
        </Button>
        <Button
          onClick={onConfirm}
          className="button button__solid--primary"
          variant="contained"
        >
          {confirmLabel}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmDeleteDialog;
